import { Component, NgZone, TemplateRef, ViewChild } from '@angular/core';
import { ColDef } from 'ag-grid-community';
import { ApiService } from '../../shared/services/api.service';
import { DateService } from '../../shared/services/date.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ImageService } from '../../shared/services/image.service';
import { AuthService } from '../../shared/services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-customers',
  templateUrl: './customers.component.html',
  standalone: false,
  styleUrls: ['./customers.component.scss']
})
export class CustomersComponent {

  gridApi: any;
  apiUrl: any;
  selectedCustomer: any;
  modalRef: any;
  customerData: any;
  @ViewChild('content') content!: TemplateRef<any>;

  constructor(private _api: ApiService,
    private _dateService: DateService,
    private modalService: NgbModal,
    private zone: NgZone,
    private _date: DateService,
    private _imageService: ImageService,
    public _auth: AuthService,
    private router: Router
  ) {

  }

  columnDefs: ColDef[] = [
    {
      headerName: 'Action',
      field: 'action',
      width: 80,
      cellRenderer: (params: any) => {
        const button = document.createElement('button');
        button.classList.add('btn', 'btn-sm', 'btn-primary', 'active', 'rounded-pill');
        button.innerHTML = '<i class="bi bi-eye-fill"></i>';
        button.addEventListener('click', () => {
          this.zone.run(() => {
            this.onView(params);
          });
        });
        return button;
      }
    },
    {
      headerName: 'Account Status',
      field: 'customerId.isFrozen',
      editable: false,
      filter: true,
      width: 150,
      filterParams: {
        filterOptions: ['contains'],
        maxNumConditions: 1,
        debounceMs: 500,
        filterPlaceholder: 'Min 3 chars (act, fro, del)'
      },
      valueFormatter: (params) => {
        const data = params.data?.customerId;
        if (data?.deletedByCustomer) {
          return 'DELETED';
        }
        return data?.isFrozen ? 'FROZEN' : 'ACTIVE';
      },
      cellClass: (params) => {
        const data = params.data?.customerId;
        if (data?.deletedByCustomer) {
          return 'text-warning';
        }
        return data?.isFrozen ? 'text-danger' : 'text-success';
      },
      cellRenderer: (params: any) => {
        const data = params.data?.customerId;
        let statusText = '';
        let reasonText = '';

        if (data?.deletedByCustomer) {
          statusText = 'DELETED';
          reasonText = data.freezeReason || 'Deleted by customer';
        } else if (data?.isFrozen) {
          statusText = 'FROZEN';
          reasonText = data.freezeReason || (data.freezeHistory && data.freezeHistory.length > 0 ? data.freezeHistory[0].reason : '');
        } else {
          statusText = 'ACTIVE';
        }

        const container = document.createElement('div');
        const statusSpan = document.createElement('span');
        statusSpan.className = `badge ${data?.deletedByCustomer ? 'bg-warning' : (data?.isFrozen ? 'bg-danger' : 'bg-success')}`;
        statusSpan.textContent = statusText;

        container.appendChild(statusSpan);

        if (reasonText) {
          const reasonSpan = document.createElement('div');
          reasonSpan.className = 'small text-muted mt-1';
          reasonSpan.textContent = reasonText;
          container.appendChild(reasonSpan);
        }

        return container;
      }
    },
    {
      headerName: 'Profile Status',
      field: 'customerId.customerStatus',
      editable: false,
      sortable: true,
      filter: true,
      filterParams: {
        filterOptions: ['contains'],
        maxNumConditions: 1
      },
      width: 150,
      valueFormatter: (params) => {
        return params.data?.customerId?.customerStatus || 'Pending';
      },
      cellRenderer: (params: any) => {
        const status = params.data?.customerId?.customerStatus || 'Pending';
        const container = document.createElement('div');
        const badge = document.createElement('span');
        let className = 'bg-secondary';
        if (status === 'Pending') {
          className = 'bg-secondary';
        } else if (status === 'In-Progress') {
          className = 'bg-warning text-dark';
        } else if (status === 'Approved') {
          className = 'bg-success';
        } else if (status === 'Rejected') {
          className = 'bg-danger';
        }
        badge.className = `badge ${className}`;
        badge.textContent = status;
        container.appendChild(badge);
        return container;
      }
    },
    {
      headerName: 'Name',
      field: 'customerId.name',
      editable: false,
      sortable: true,
      filter: true,
      filterParams: {
        filterOptions: ['contains'],
        maxNumConditions: 1
      }
    },
    {
      headerName: 'Email Id',
      field: 'customerId.emailId',
      editable: false,
      sortable: true,
      filter: true,
      filterParams: {
        filterOptions: ['contains'],
        maxNumConditions: 1
      }
    },
    {
      headerName: 'Date of Birth',
      field: 'customerId.dob',
      editable: false,
      sortable: false,
      filter: false,
      valueFormatter: (params) => {
        const dob = params.data?.customerId?.dob;
        if (!dob) return '—';
        const date = new Date(dob);
        if (isNaN(date.getTime())) return '—';
        const dobFormat = params.data?.customerId?.citizenshipCountry?.dobFormat || params.data?.customerId?.country?.dobFormat || 'DD-MM-YYYY';
        let d = String(date.getDate()).padStart(2, '0');
        let m = String(date.getMonth() + 1).padStart(2, '0');
        const y = date.getFullYear().toString();
        if (dobFormat === 'MM-DD-YYYY') return `${m}-${d}-${y}`;
        if (dobFormat === 'YYYY-MM-DD') return `${y}-${m}-${d}`;
        return `${d}-${m}-${y}`;
      },
    },
    {
      headerName: 'Device Id',
      field: 'customerId.deviceId',
      editable: false,
      filter: false,
    },
    {
      headerName: 'Source Partner',
      field: 'partnerId.name',
      editable: false,
      sortable: false,
      filter: false,
    },
    {
      headerName: 'Country',
      field: 'customerId.country.displayName',
      editable: false,
      sortable: true,
      filter: true,
      filterParams: {
        filterOptions: ['contains'],
        maxNumConditions: 1
      }
    },
    {
      headerName: 'Citizenship',
      field: 'customerId.citizenshipCountry.displayName',
      editable: false,
      sortable: true,
      filter: true,
      filterParams: {
        filterOptions: ['contains'],
        maxNumConditions: 1
      }
    },
    {
      headerName: 'Mobile',
      field: 'customerId.mobile',
      editable: false,
      sortable: true,
      filter: true,
      filterParams: {
        filterOptions: ['contains'],
        maxNumConditions: 1
      },
      valueFormatter: (params) => {
        const mobile = params.value;
        if (!mobile) return '';

        const cleanMobile = mobile.replace(/[\s-]/g, '');
        const dialingCode = params.data?.customerId?.country?.dialingCode;

        if (dialingCode) {
          const numberPart = cleanMobile.replace(dialingCode, '');
          if (numberPart && numberPart !== cleanMobile) {
            return `${dialingCode} ${numberPart}`;
          }
        }

        if (cleanMobile.startsWith('+91')) {
          return '+91 ' + cleanMobile.slice(3);
        } else {
          const countryCodeMatch = cleanMobile.match(/^(\+\d{1,3})(.*)$/);
          if (countryCodeMatch && countryCodeMatch[2]) {
            return `${countryCodeMatch[1]} ${countryCodeMatch[2]}`;
          }
        }

        return mobile;
      }
    },
    {
      headerName: 'Registered On',
      field: 'createdAt',
      editable: false,
      sortable: true,
      filter: false,
      valueFormatter: (params) =>
        this._dateService.getFormattedDateWithAMPM(params.value),
    },

  ];

  gridOptions: any = {
    paginationPageSize: 15,
    cacheBlockSize: 15,
    pagination: true,
    rowModelType: 'infinite',
    paginationPageSizeSelector: [15, 20, 50, 100],
    datasource: this.createDataSource(),
    rowSelection: 'multiple',
    context: {
      componentParent: this,
    },
  };

  onGridReady(params: any) {
    const vm = this;
    vm.gridApi = params.api;
    if (vm.gridApi) {
      vm.gridApi = params.api;
      // vm.gridApi.sizeColumnsToFit();
    }
  }

  createDataSource() {
    const vm = this;
    const user = vm._auth.getUser();
    const datasource = {
      getRows: (params: any) => {
        const startRow = params.startRow;
        const request = {
          _page: startRow / vm.gridOptions.paginationPageSize + 1,
          _limit: vm.gridOptions.paginationPageSize,
        };
        this.apiUrl = '/partners/auth/customers?_page=' + request._page + '&_limit=' + request._limit;
        const filterData = vm.gridApi.getFilterModel();
        Object.keys(filterData).forEach(k => {
          if (k && filterData[k]) {
            const filterValue = filterData[k].filter.replace(/\s/g, '');
            vm.apiUrl = vm.apiUrl + '&' + k + '_like=' + encodeURIComponent(filterValue);
          }
        });
        if (params.sortModel && params.sortModel.length > 0) {
          const sortFields = params.sortModel.map(s => s.colId).join(',');
          const sortOrders = params.sortModel.map(s => s.sort).join(',');
          vm.apiUrl = vm.apiUrl + '&_sort=' + encodeURIComponent(sortFields) + '&_order=' + encodeURIComponent(sortOrders);
        }
        vm._api.getData(this.apiUrl).subscribe((res: any) => {
          if (res && !res.error) {
            const dt: any = [];
            Object.keys(res.data).map(r => {
              const obj = { type: r, value: res.data[r] };
              dt.push(obj);
            });
            
            res.data.value = dt;
            params.successCallback(res.data, res.count);
            //vm.gridApi.sizeColumnsToFit();
          } else {
            params.failCallback();
          }
        });
      },
    };
    return datasource;
  }

  onView(data: any) {
    const customer = data.data;
    this.router.navigate(['/app/customers/details'], { queryParams: { id: customer.customerId._id } });
  }

  getCustomerDetails(id) {
    const vm = this;
    const apiUrl = '/partners/auth/profile/' + id + '?_t=' + Date.now();
    vm._api.getData(apiUrl).subscribe((res: any) => {
      if (res && !res.error) {
        vm.customerData = res.data;
        
      }
    });
  }

  onClose() {
    this.modalRef.close();
  }

  dateFormat(value: any) {
    const vm = this;
    return vm._date.getDDMMYYYYfromEPOC(value);
  }

  getImage(id) {
    if (id && id.startsWith('http')) {
      id = new URL(id).pathname.split('/').pop();
    }
    const vm = this;
    vm._imageService.fetchAndViewDoc(id);
  }



}
